import React from "react";
import PESLogo from "../../icons/PES_Logo.png";
import styles from "./PDFExport.module.scss";

interface ReportHeaderProps {
  reportNumber: string;
  clientName: string;
  email: string;
  date: string;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({
  reportNumber,
  clientName,
  email,
  date,
}) => {
  return (
    <header className={styles.header} aria-label="Report Header">
      <section className={styles.logoContainer} aria-label="Company Logo">
        <img
          src={PESLogo}
          alt="PES Technologies Logo"
          width={100}
          height={100}
        />
        <p className={styles.logoText}>TECHNOLOGIES</p>
      </section>
      <article className={styles.reportInfo} aria-label="Report Information">
        <p className={styles.reportInfoItem}>
          <strong>Report Number:</strong> {reportNumber}
        </p>
        <p className={styles.reportInfoItem}>
          <strong>Client name:</strong> {clientName || "N/A"}
        </p>
        <p className={styles.reportInfoItem}>
          <strong>Date:</strong>
          <span className={styles.date}>{date}</span>
        </p>
        <p className={styles.reportInfoItem}>
          <strong>Email:</strong>
          <span className={styles.email}>{email || "N/A"}</span>
        </p>
      </article>
    </header>
  );
};

export default ReportHeader;
